import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { adminApi } from '../adminApi';

export function useCatalogProductOffers(productId: number) {
  const [page, setPage] = useState(1);
  const [availability, setAvailability] = useState('');
  const query = useQuery({ queryKey: ['catalog', 'offers', productId, page, availability], queryFn: () => adminApi.getProductOffers({ product_id: productId, page, per_page: 10, offer_availability: availability === '' ? null : availability === 'available' }) });
  const changeAvailability = (value: string): void => { setAvailability(value); setPage(1); };
  return { query, page, setPage, availability, changeAvailability };
}

export function useCatalogCategoryProducts(categoryId: number) {
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [queryText, setQueryText] = useState('');
  useEffect(() => {
    const timer = window.setTimeout(() => { setQueryText(search.trim()); setPage(1); }, 250);
    return () => window.clearTimeout(timer);
  }, [search]);
  const query = useQuery({ queryKey: ['catalog', 'category-products', categoryId, page, queryText], queryFn: () => adminApi.getCatalogProducts({ product_category_id: categoryId, search: queryText, page, per_page: 10 }) });
  return { query, page, setPage, search, setSearch };
}

export function useCatalogChildCategories(categoryId: number) {
  const [page, setPage] = useState(1);
  const query = useQuery({ queryKey: ['catalog', 'children', categoryId, page], queryFn: () => adminApi.getCatalogCategories({ category_parent_id: categoryId, page, per_page: 10 }) });
  return { query, page, setPage };
}
